document.addEventListener("DOMContentLoaded", () => {
  const isDesktop = () =>
    window.matchMedia("(any-hover: hover) and (min-width: 1024px)").matches;

  // Sélectionne les <li> avec bouton qui contrôle un menu
  const menuItems = document.querySelectorAll(
    'ul[x-ref="navigation"] li:has(button[aria-controls])'
  );

  menuItems.forEach((li) => {
    const button = li.querySelector("button[aria-controls]");
    if (!button) return;

    const menuId = button.getAttribute("aria-controls");
    const panel = document.getElementById(menuId);

    if (!panel) return;

    // Ouvrir au survol du <li> (simulate click)
    li.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;
      if (button.getAttribute("aria-expanded") === "false") {
        button.click();
      }
    });

    // Fermer uniquement quand on quitte le panneau
    panel.addEventListener("mouseleave", () => {
      if (!isDesktop()) return;
      if (button.getAttribute("aria-expanded") === "true") {
        button.click();
      }
    });
  });
});
